module.exports = __webpack_public_path__ + "static/media/leadership_background_top_right.3c07e8ae.svg";